import { Capacitor } from '@capacitor/core'
import { Keyboard } from '@capacitor/keyboard'
import { useNavigate } from 'react-router-dom'
import { getDelayPromise } from '../../utils'

export const useGlobalRouter = () => {
    const nav = useNavigate()

    const pushPath = async (
        path: string,
        options?: { animation?: 'auto' | 'none' | 'right' | 'left' }
    ) => {
        let animOption = options?.animation ?? 'auto'
        if (Capacitor.isNativePlatform()) {
            await Keyboard.hide()
        }
        if (animOption === 'none') {
            nav(path)
            return
        }
        if (animOption === 'auto') {
            const destinationPaths = path.split('/').length
            const currentPaths = window.location.pathname.split('/').length
            if (destinationPaths >= currentPaths) {
                animOption = 'right'
            } else {
                animOption = 'left'
            }
        }
        try {
            if ((document as any).startViewTransition) {
                ;(document as any).startViewTransition({
                    update: async () => {
                        nav(path)
                        // wait for 100ms to let the animation finish
                        await getDelayPromise(100)
                    },
                    types: ['slide', animOption],
                })
                return
            }
        } catch (error) {
            nav(path)
            return
        }
        nav(path)
    }

    const replacePath = async (path: string) => {
        let animOption = 'right'

        const destinationPaths = path.split('/').length
        const currentPaths = window.location.pathname.split('/').length
        if (destinationPaths > currentPaths) {
            animOption = 'right'
        } else {
            animOption = 'left'
        }
        try {
            if ((document as any).startViewTransition) {
                ;(document as any).startViewTransition({
                    update: async () => {
                        nav(path, { replace: true })
                        // wait for 100ms to let the animation finish
                        await getDelayPromise(100)
                    },
                    types: ['slide', animOption],
                })
                return
            }
        } catch (error) {
            nav(path, { replace: true })
            return
        }
        nav(path, { replace: true })
    }

    const goBack = async (useRight?: boolean) => {
        let animOption = 'left'

        if (useRight) animOption = 'right'
        try {
            if ((document as any).startViewTransition) {
                ;(document as any).startViewTransition({
                    update: async () => {
                        nav(-1)
                        // wait for 100ms to let the animation finish
                        await getDelayPromise(100)
                    },
                    types: ['slide', animOption],
                })
                return
            }
        } catch (error) {
            nav(-1)
            return
        }
        nav(-1)
    }

    return { pushPath, replacePath, goBack }
}
